<template>
  <div class="historico-beneficiarios-filtro">
    <b-form>      
    <HistoricoBeneficiarioPainel :empresaOptions="empresaOptions" :empresaSelected="this.form.empresa" :refresh="refresh" @selectEmpresa="changeEmpresa"/>

      <div class="d-flex align-items-center p-4">
        <div class="title title-primary d-flex w-50 m-0">
          <DynamicIcon icon="multiple-letter" classString="container-title-icon mr-2"/>
          <p class="d-flex align-items-center mt-1 optum-bold font-24px">Lista de Beneficiários</p> 
        </div>
        <div class="w-50 d-flex justify-content-end">
          <b-button pill class="btn-base primary-btn" @click="add">Cadastrar titular</b-button>
          <ModalCadastrarBeneficiario v-if="modal" @close="modal = null" :acao="acao"/>
        </div>
        
      </div>
      
      <ToogleFilterBox classString="mx-4" title="Filtrar" :isFilter="true" @filter="filter" @resetFilter="resetFilter">
        <div class="row col-md-12 m-0 p-0">
            <b-form-group label="Nome" required label-for="nome" class="col-12 col-md-3 px-1">
              <b-form-input id="nome" v-model="form.nome" placeholder="Digite aqui" trim />
            </b-form-group>
            <b-form-group label="CPF" label-for="cpf" class="col-12 col-md-3 px-1">
                <b-form-input id="cpf" v-model="form.cpf" placeholder="Digite aqui" v-mask="['###.###.###-##']"/>
            </b-form-group>
            <b-form-group label="Tipo" label-for="tipo" class="col-12 col-md-2 px-1">
              <b-form-select id="tipo" v-model="form.tipo" :options="tipoOptions"/>
            </b-form-group>
            <b-form-group label="Status" label-for="status" class="col-12 col-md-2 px-1">
              <b-form-select id="status" v-model="form.status" :options="statusOptions"/>
            </b-form-group>
            <b-form-group label="Serviço" label-for="produto" class="col-12 col-md-2 px-1">
              <b-form-select id="produto" v-model="form.produto" :options="produtoOptions"/>
            </b-form-group>
        </div>       
      </ToogleFilterBox>

    </b-form>
  </div>
</template>

<script>
import Validations from '@/util/Validations'
import ModalCadastrarBeneficiario from './ModalCadastrarBeneficiario.vue'
import HistoricoBeneficiarioPainel from './HistoricoBeneficiarioPainel.vue'
import EmpresaResource from "@/resources/EmpresaResource"
import DynamicIcon from "@/components/commons/dynamicIcon/DynamicIcon.vue";
import ToogleFilterBox from "@/components/commons/ToogleFilterBox.vue";
import { getStatusOptions, getTipoOptions } from "@/util/BeneficiarioUtils.js"
import { mapGetters } from "vuex"
import { mask } from 'vue-the-mask'

const produtoOptionsDefault = { value: null, text: '(Selecione uma empresa)'}

export default {
  
    name: "HistoricoBeneficiarioFilter",
    components:{
      ModalCadastrarBeneficiario,
      HistoricoBeneficiarioPainel,
      DynamicIcon,
      ToogleFilterBox
    },
    props: {
      cleanFilter: Boolean,
      empresaOptions: Array,
    },
    directives: {mask},
    data() {
      return {
        modal: null,
        acao: null,
        refresh: false,
        form : {
            cpf: null,
            nome: null,
            tipo: null,
            status: 1,
            empresa: null,
            produto: null
        },
        tipoOptions: getTipoOptions(),
        statusOptions: getStatusOptions (),
        produtoOptions: [produtoOptionsDefault]
      }
	},
  computed: {
      ...mapGetters("user", ["authorities"]),
      isAdmin () {
          if ( this.authorities ) {
              return this.authorities.includes("ROLE_ADMIN")
          }   
          return false;
      }
  },
  methods: {
      add () {
        this.modal = true
        this.acao = "CADASTRAR"
      },
      filter() {
        if( Validations.isEmpty(this.form) ) {
          this.$emit("filter-historico-beneficiario", {} )    
        }
        else {
            let form = {
                ...this.form,
                cpf: this.form.cpf != null ? this.form.cpf.replace(/\D/g, '') : null,
                nome: this.form.nome != null ? this.form.nome.toUpperCase() : null,
                tipo: this.form.tipo,
                status: this.form.status,
                empresa: this.form.empresa
            }

            
            this.$emit("filter-historico-beneficiario", form)
        }        
      },
      resetFilter() {
          for (let key in this.form)
          {
              this.form[key] = null
          }  
      },
      changeEmpresa( empresaId )
      {
        this.form.empresa = empresaId ? empresaId : null
        this.getProdutosOptions()
        this.filter()  
      },
      getProdutosOptions() {

        if(this.empresaOptions.length == 1)
          this.form.empresa = this.empresaOptions[0].value
        
        if(!this.form.empresa) {
          this.produtoOptions = [produtoOptionsDefault]
          return
        }

        EmpresaResource.produtosOptions(this.form.empresa, {showLoader: true})
        .then( result => {
            this.produtoOptions = [{value: null, text: '(Selecione)' }, ...result.map(elem => { return {value: elem.id, text: elem.text } } )]
        }) 
      }
  },
  watch: {
    cleanFilter: function(newVal) {
      this.refresh = true
      if(newVal)
      {
        this.resetFilter()
        this.filter()
      }
    },
    empresaSelected: function(newVal) {
      this.form.empresa = newVal
    }
  },
  created(){
    this.getProdutosOptions()   
  }
}
</script>
<style scoped>
.historico-beneficiarios-filtro {
	justify-content: space-between;
  color: #707070;
	font-size: 18px;
	text-align: left;
}

.label-filter-cases {
    width: 100%;
    height: 45px;
    color: #EFEFEE !important;    
    background-color: #bbbec0;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px !important;
    letter-spacing: 2px !important;
    border-radius: 10px 10px 0px 0px;
    transition: 0.2s;
}

.label-filter-cases:hover{
    cursor: pointer;
    background-color: #9d9fa0;
}

input, select {
    font-size: 14px !important;
    border: 1px solid #bbbec0 !important;  
}

.form-filter-cases, .form-filter-cases-flex  {
    width: 100%;
    display: flex;
    padding: 15px 0px;
    flex-wrap: wrap;
    transition: 0.2s;
    background-color: #fff;
    border-radius: 0px 0px 10px 10px;
}

.form-select {
  border: none !important;
  outline: none !important;
  scroll-behavior: smooth !important;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgb(0, 38, 119)' stroke-linecap='round' stroke-linejoin='round' stroke-width='4' d='m2 5 6 6 6-6'/%3e%3c/svg%3e");
  color: rgb(0, 38, 119) !important;
  font-weight: bold !important;
  cursor: pointer !important;
}

select.form-select option {
  border: none !important;
  outline: none !important;
  scroll-behavior: smooth !important;
  font-weight: bold !important;
}

</style>